module.exports = __webpack_public_path__ + "img/protester8.d6ca25f0.jpeg";